<template>
  <div class="global-overlay" :class="{ 'global-dark': darkTransparent }" @wheel="onChange" @click="onChange">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class GlobalOverlay extends Vue {
  @Prop({ default: false }) private darkTransparent!: boolean

  onChange(event: Event) {
    this.$emit(event.type, event)
  }

  created() {
    document.documentElement.style.overflow = 'hidden'
  }

  beforeDestroy() {
    document.documentElement.style.overflow = ''
  }
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles' as *;

.global-overlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: white;
  z-index: $notch-layer-covering-overlay;
  overflow-y: auto;
}

.global-dark {
  background-color: rgba(0, 0, 0, 0.7);
}
</style>
